/**
 * 商品ページ「Target」入力フィールド用スクリプト
 * - submitをインターセプトし、Target必須バリデーション
 * - バリデーション通過後はテーマのカート追加処理に任せる（二重送信防止）
 * - カート追加成功後に cart note へ target を記録
 */
(function () {
  if (window.__customNameFormInit) return;
  window.__customNameFormInit = true;

  var CART_UPDATE_EVENT = 'cart:update';

  /**
   * ネイティブバリデーションポップアップを抑制し、カスタムエラーを表示する。
   */
  function initCustomValidation() {
    document
      .querySelectorAll('.custom-name-field input[required], .custom-name-field textarea[required]')
      .forEach(function (input) {
        input.addEventListener('invalid', function (e) {
          e.preventDefault();
          showError(input, true);
          input.setAttribute('aria-invalid', 'true');
        });

        input.addEventListener('input', function () {
          if ((input.value || '').trim()) {
            showError(input, false);
            input.setAttribute('aria-invalid', 'false');
            input.setCustomValidity('');
          }
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomValidation);
  } else {
    initCustomValidation();
  }

  function getRoutes() {
    if (typeof Theme !== 'undefined' && Theme.routes) {
      var r = Theme.routes;
      return {
        cart_update_url:
          r.cart_update_url && r.cart_update_url.indexOf('.js') > -1
            ? r.cart_update_url
            : (r.cart_update_url || '/cart/update') + '.js',
      };
    }
    return { cart_update_url: '/cart/update.js' };
  }

  function getNameInputForForm(form) {
    var formId = form.getAttribute('id');
    if (!formId) return null;
    return document.querySelector('input[name="properties[target]"][form="' + formId + '"]');
  }

  function getErrorEl(input) {
    if (!input) return null;
    var field = input.closest('.custom-name-field');
    return field ? field.querySelector('[data-custom-name-error]') : null;
  }

  function showError(input, show) {
    var err = getErrorEl(input);
    if (!err) return;
    if (show) {
      err.classList.remove('hidden');
      err.setAttribute('aria-live', 'assertive');
    } else {
      err.classList.add('hidden');
      err.removeAttribute('aria-live');
    }
  }

  function isAddToCartForm(form) {
    return (
      form.getAttribute('data-type') === 'add-to-cart-form' ||
      (form.id && form.id.indexOf('BuyButtons-ProductForm-') === 0)
    );
  }

  // 保留中のノート更新情報
  var pendingNoteValue = null;

  /**
   * Step 1: submitイベントをインターセプトしてバリデーションのみ実行。
   * バリデーション通過後はテーマの ProductFormComponent.handleSubmit に処理を委譲する。
   *
   * 【修正前の問題】
   * このリスナーと component.js（テーマ）のリスナーが両方ともキャプチャフェーズで
   * document に登録されており、テーマが先に登録されるため、テーマのカート追加が
   * 先に実行された後にこのリスナーが再度カート追加を行い、合計2回追加されていた。
   *
   * 【修正後】
   * バリデーションのみ担当。カート追加はテーマに任せる。
   * properties[target] フィールドは form 属性で紐付いているため、
   * テーマの FormData にラインアイテムプロパティとして自動的に含まれる。
   */
  document.addEventListener(
    'submit',
    function (ev) {
      var form = ev.target;
      if (!form || !isAddToCartForm(form)) return;

      var nameInput = getNameInputForForm(form);
      if (!nameInput) return;

      var nameValue = (nameInput.value || '').trim();

      // 空欄の場合はテーマへの伝播も含めて完全にブロック
      if (nameValue === '') {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        showError(nameInput, true);
        nameInput.setAttribute('aria-invalid', 'true');
        nameInput.focus();
        return;
      }

      // バリデーション通過：エラーをクリア
      showError(nameInput, false);
      nameInput.setAttribute('aria-invalid', 'false');

      // カート追加後のノート更新に必要な値を保存
      pendingNoteValue = nameValue;

      // ここでは preventDefault / stopImmediatePropagation を呼ばない。
      // テーマの ProductFormComponent.handleSubmit がカート追加を処理する。
      // properties[target] フィールドはテーマの FormData に自動的に含まれるため
      // ラインアイテムプロパティも自動で設定される。
    },
    true // キャプチャフェーズ
  );

  /**
   * Step 2: テーマのカート追加完了後に cart note を更新する。
   * CartAddEvent は 'cart:update' イベントとして dispatch される。
   */
  document.addEventListener(CART_UPDATE_EVENT, function (ev) {
    if (!pendingNoteValue) return;

    var source = ev.detail && ev.detail.data && ev.detail.data.source;
    if (source !== 'product-form-component') return;

    // エラー時はクリアして終了
    if (ev.detail && ev.detail.data && ev.detail.data.didError) {
      pendingNoteValue = null;
      return;
    }

    var noteValue = pendingNoteValue;
    pendingNoteValue = null;

    // cart note に target 情報を追記
    var routes = getRoutes();

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var existingNote = (cart.note || '').trim();
        var newLine = 'target:' + noteValue;
        var newNote = existingNote ? existingNote + '\n' + newLine : newLine;

        return fetch(routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ note: newNote }),
        });
      })
      .catch(function (err) {
        console.warn('custom-name-form: cart note update failed', err);
      });
  });
})();
